import _classCallCheck from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */

/* Original source: keras/contraints.py */
import * as tfc from '@tensorflow/tfjs-core';
import { serialization, tidy } from '@tensorflow/tfjs-core';
import { epsilon } from './backend/common';
import { deserializeKerasObject, serializeKerasObject } from './utils/generic_utils';
/**
 * Helper function used by many of the Constraints to find the L2Norms.
 */

function calcL2Norms(w, axis) {
  return tidy(function () {
    return tfc.sqrt(tfc.sum(tfc.mul(w, w), axis, true));
  });
}
/**
 * Base class for functions that impose constraints on weight values
 *
 * @doc {
 *   heading: 'Constraints',
 *   subheading: 'Classes',
 *   namespace: 'constraints'
 * }
 */


export var Constraint = /*#__PURE__*/function (_serialization$Serial) {
  _inherits(Constraint, _serialization$Serial);

  function Constraint() {
    _classCallCheck(this, Constraint);

    return _possibleConstructorReturn(this, _getPrototypeOf(Constraint).apply(this, arguments));
  }

  _createClass(Constraint, [{
    key: "getConfig",
    value: function getConfig() {
      return {};
    }
  }]);

  return Constraint;
}(serialization.Serializable);
export var MaxNorm = /*#__PURE__*/function (_Constraint) {
  _inherits(MaxNorm, _Constraint);

  function MaxNorm(args) {
    var _this;

    _classCallCheck(this, MaxNorm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MaxNorm).call(this));
    _this.defaultMaxValue = 2;
    _this.defaultAxis = 0;
    _this.maxValue = args.maxValue != null ? args.maxValue : _this.defaultMaxValue;
    _this.axis = args.axis != null ? args.axis : _this.defaultAxis;
    return _this;
  }

  _createClass(MaxNorm, [{
    key: "apply",
    value: function apply(w) {
      var _this2 = this;

      return tidy(function () {
        var norms = calcL2Norms(w, _this2.axis);
        var desired = tfc.clipByValue(norms, 0, _this2.maxValue);
        return tfc.mul(w, tfc.div(desired, tfc.add(epsilon(), norms)));
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        maxValue: this.maxValue,
        axis: this.axis
      };
    }
  }]);

  return MaxNorm;
}(Constraint);
/** @nocollapse */

MaxNorm.className = 'MaxNorm';
serialization.registerClass(MaxNorm);
export var UnitNorm = /*#__PURE__*/function (_Constraint2) {
  _inherits(UnitNorm, _Constraint2);

  function UnitNorm(args) {
    var _this3;

    _classCallCheck(this, UnitNorm);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(UnitNorm).call(this));
    _this3.defaultAxis = 0;
    _this3.axis = args.axis != null ? args.axis : _this3.defaultAxis;
    return _this3;
  }

  _createClass(UnitNorm, [{
    key: "apply",
    value: function apply(w) {
      var _this4 = this;

      return tidy(function () {
        return tfc.div(w, tfc.add(epsilon(), calcL2Norms(w, _this4.axis)));
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        axis: this.axis
      };
    }
  }]);

  return UnitNorm;
}(Constraint);
/** @nocollapse */

UnitNorm.className = 'UnitNorm';
serialization.registerClass(UnitNorm);
export var NonNeg = /*#__PURE__*/function (_Constraint3) {
  _inherits(NonNeg, _Constraint3);

  function NonNeg() {
    _classCallCheck(this, NonNeg);

    return _possibleConstructorReturn(this, _getPrototypeOf(NonNeg).apply(this, arguments));
  }

  _createClass(NonNeg, [{
    key: "apply",
    value: function apply(w) {
      return tfc.relu(w);
    }
  }]);

  return NonNeg;
}(Constraint);
/** @nocollapse */

NonNeg.className = 'NonNeg';
serialization.registerClass(NonNeg);
export var MinMaxNorm = /*#__PURE__*/function (_Constraint4) {
  _inherits(MinMaxNorm, _Constraint4);

  function MinMaxNorm(args) {
    var _this5;

    _classCallCheck(this, MinMaxNorm);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(MinMaxNorm).call(this));
    _this5.defaultMinValue = 0.0;
    _this5.defaultMaxValue = 1.0;
    _this5.defaultRate = 1.0;
    _this5.defaultAxis = 0;
    _this5.minValue = args.minValue != null ? args.minValue : _this5.defaultMinValue;
    _this5.maxValue = args.maxValue != null ? args.maxValue : _this5.defaultMaxValue;
    _this5.rate = args.rate != null ? args.rate : _this5.defaultRate;
    _this5.axis = args.axis != null ? args.axis : _this5.defaultAxis;
    return _this5;
  }

  _createClass(MinMaxNorm, [{
    key: "apply",
    value: function apply(w) {
      var _this6 = this;

      return tidy(function () {
        var norms = calcL2Norms(w, _this6.axis);
        var desired = tfc.add(tfc.mul(_this6.rate, tfc.clipByValue(norms, _this6.minValue, _this6.maxValue)), tfc.mul(1.0 - _this6.rate, norms));
        return tfc.mul(w, tfc.div(desired, tfc.add(epsilon(), norms)));
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        minValue: this.minValue,
        maxValue: this.maxValue,
        rate: this.rate,
        axis: this.axis
      };
    }
  }]);

  return MinMaxNorm;
}(Constraint);
/** @nocollapse */

MinMaxNorm.className = 'MinMaxNorm';
serialization.registerClass(MinMaxNorm); // Maps the JavaScript-like identifier keys to the corresponding registry
// symbols.

export var CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP = {
  'maxNorm': 'MaxNorm',
  'minMaxNorm': 'MinMaxNorm',
  'nonNeg': 'NonNeg',
  'unitNorm': 'UnitNorm'
};
export function serializeConstraint(constraint) {
  return serializeKerasObject(constraint);
}
export function deserializeConstraint(config) {
  var customObjects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return deserializeKerasObject(config, serialization.SerializationMap.getMap().classNameMap, customObjects, 'constraint');
}
export function getConstraint(identifier) {
  if (identifier == null) {
    return null;
  }

  if (typeof identifier === 'string') {
    var className = identifier in CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP ? CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP[identifier] : identifier;
    var config = {
      className: className,
      config: {}
    };
    return deserializeConstraint(config);
  } else if (identifier instanceof Constraint) {
    return identifier;
  } else {
    return deserializeConstraint(identifier);
  }
}